import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function chartKpiLabel(): ComponentStyle {
  return {
    componentName: 'chartKpiLabel',
    baseStyle: {}
  };
}
